import React from 'react';

const VersionIcons = () => {
  return (
	<b>Version Icon TODO</b>
  );
};

export default VersionIcons;

